@if (isNotEmptyArray(groups())) {
  <div class="rounded-lg border border-gray-200 p-4">
    <p-accordion [multiple]="true">
      @for (group of groups(); track group.id ?? index; let index = $index) {
        <p-accordion-panel [value]="index">
          <p-accordion-header>
            <div class="flex items-center gap-2 text-sm text-gray-400">
              <span>#{{ index + 1 }}</span>
              <span>Grupa zawartości</span>
            </div>
          </p-accordion-header>

          <p-accordion-content class="overflow-x-auto">
            <div class="flex flex-col gap-4">
              @if (showQuestionnaireVisibility()) {
                <div class="text-sm text-gray-600">
                  Widoczne w ankiecie:
                  <span class="font-medium text-gray-900">
                    {{ group.isVisibleInQuestionnaire | boolean }}
                  </span>
                </div>
              }

              @if (group.description) {
                <app-summernote-html-preview [html]="group.description" />
              }

              <app-box-component-group-cosmetics-table
                [items]="group.cosmetics"
                [showAvailableQuantity]="showAvailableQuantity()"
                [showRemainingQuantity]="showRemainingQuantity()" />
            </div>
          </p-accordion-content>
        </p-accordion-panel>
      }
    </p-accordion>
  </div>
} @else {
  <app-no-data />
}
